// src/modules/Caregaps2/common/helpers.js
import {
  WORKFLOW_STATUS_LABELS,
  CARE_GAP_STATUS_LABELS,
} from "./constants";

export function formatDate(d) {
  if (!d) return "—";
  const date = typeof d === "string" ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString();
}

// status que usamos en el chip principal = workflowStatusCode
export function statusColor(status) {
  switch (status) {
    case "NEW":
      return "default";
    case "CONTACT_ATTEMPTED":
      return "warning";
    case "CONTACTED":
      return "info";
    case "SCHEDULED":
      return "primary";
    case "EVIDENCE_UPLOADED":
      return "secondary";
    case "VERIFIED":
      return "success";
    case "CLOSED_BY_USER":
      return "success";
    case "EXEMPT":
      return "default";
    default:
      // por si en algún momento decides usar sourceStatusCode (OPEN/CLOSED/SUBMITTED)
      switch (status) {
        case "OPEN":
          return "warning";
        case "CLOSED":
          return "success";
        case "SUBMITTED":
          return "secondary";
        default:
          return "default";
      }
  }
}

export function initialsFromMeasure(name) {
  if (!name) return "CG";
  const parts = name.split(" ").filter(Boolean);
  const letters = parts.map((p) => p[0]).slice(0, 3).join("");
  return letters.toUpperCase();
}

export function statusLabel(status) {
  // Primero intentamos workflow status, luego care gap status
  return (
    WORKFLOW_STATUS_LABELS[status] ||
    CARE_GAP_STATUS_LABELS[status] ||
    status ||
    "Unknown"
  );
}
